import { FormControl } from "@mui/material";
import { useContext } from "react";
import { useForm } from "react-hook-form";
import { LocalizationContext } from "src/lib/context";
import LoadingMuiButton from "./LoadingMuiButton";
import { MuiInput } from "./MuiInput";

export default function UpdatableInput({
  defaultValue,
  onChange,
  onSubmit,
  loading,
  inputStrings,
  type,
  allEquipment,
  existing,
  actDroner,
  user,
  userData,
}) {
  const { localeStrings } = useContext(LocalizationContext);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    ...userData,
    uid: user?.uid,
  });

  return (
    <FormControl
      sx={{
        gap: 2,
        width: "100%",
        maxWidth: 600,
        margin: "0 auto",
        display: "grid",
        gridTemplateColumns: "1fr max-content",
        alignItems: "center",
      }}
      component="form"
      onSubmit={handleSubmit(onSubmit)}
    >
      {type === "textField" && (
        <MuiInput
          inputStrings={inputStrings}
          defaultValue={defaultValue}
          errors={errors}
          register={register}
          onChange={onChange}
        />
      )}

      {type === "location" && (
        <MuiInput
          inputStrings={inputStrings}
          errors={errors}
          register={register}
          onChange={() => {}}
          type="location"
          control={control}
        />
      )}

      {type === "equipment" && (
        <MuiInput
          inputStrings={inputStrings}
          errors={errors}
          register={register}
          onChange={() => {}}
          type="equipment"
          allEquipment={allEquipment}
          control={control}
        />
      )}

      {type === "skills" && (
        <MuiInput
          inputStrings={inputStrings}
          errors={errors}
          register={register}
          onChange={() => {}}
          existing={existing}
          actDroner={actDroner}
          control={control}
          type="skills"
        />
      )}

      <LoadingMuiButton
        loading={loading}
        text={localeStrings.uiGeneral.saveButton}
      />
    </FormControl>
  );
}
